import StackWithDivider from '@/components/StackWithDivider';
import BoardDetailLikes, {
  BoardDetailLikesRef,
} from '@/components/Board/BoardDetail/Feedback/BoardDetailLikes';
import { BoardDetailData } from '@/types/board';
import { StackProps } from '@mui/material';
import { Ref } from 'react';
import BoardDetailComment, {
  BoardDetailCommentProps,
  BoardDetailCommentRef,
} from '@/components/Board/BoardDetail/Feedback/BoardDetailComment/index';

type BoardDetailFeedbackProps = {
  data: BoardDetailData;
  disabled?: boolean;
  boardDetailLikesRef: Ref<BoardDetailLikesRef>;
  boardDetailCommentRef: Ref<BoardDetailCommentRef>;
  isRowDirection: boolean;
  isMobile: boolean;
} & StackProps &
  Pick<BoardDetailCommentProps, 'onChangeCount' | 'handleComment'>;

const BoardDetailFeedback = (_props: BoardDetailFeedbackProps) => {
  const {
    data,
    disabled,
    boardDetailLikesRef,
    boardDetailCommentRef,
    isRowDirection,
    onChangeCount,
    handleComment,
    isMobile,
    ...props
  } = _props;
  return (
    <StackWithDivider
      sx={{ padding: '16px 0' }}
      dividerProps={{ sx: { marginTop: '20px' } }}
      gap={isMobile ? '24px' : 0}
      {...props}
    >
      <BoardDetailLikes
        ref={boardDetailLikesRef}
        documentId={data.id}
        disabled={disabled}
      />
      <BoardDetailComment
        ref={boardDetailCommentRef}
        commentGroupId={data.commentGroupId}
        disabled={disabled}
        inputStyle={isMobile ? 'mobile' : isRowDirection ? 'fixed' : 'top'}
        onChangeCount={onChangeCount}
        handleComment={handleComment}
        service={'board'}
      />
    </StackWithDivider>
  );
};

export default BoardDetailFeedback;
